/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import map from 'lodash/map';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import Row, { Col } from 'components/row';
import Image from 'components/image';
import CollapseLines from 'components/clamp-lines';

import translates from '../about-i18n.json';

const classes = new Bem('blockOurTeam');

@I18nHoc(translates)
export default class OurTeam extends Component {
  static propTypes = {
    className: PropTypes.string,
    ourTeam: PropTypes.shape({})
  };

  render() {
    const { i18n } = this;
    const { className, ourTeam } = this.props;
    const ourTeamData = get(ourTeam, 'data') || [];

    if (!ourTeamData.length) return null;

    return (
      <div {...classes({ extra: className })}>
        <Row {...classes('row', 'topic')}>
          <Col allPr={0}><div {...classes('text', 'h2')}><h2 children={i18n('ourTeam')} /></div></Col>
        </Row>
        <Row {...classes('row', 'block')} mpColumn>
          {map(ourTeamData, (member, key) => (
            <Col key={key} {...classes('col', 'item')} mdAuto allPr={0}>
              <Image
                {...classes('imgPic')}
                image={{
                  id: get(member, 'images[0]'),
                  // renderer: 'orig'
                }}
                fullScreenSwitch="none"
              />
              <CollapseLines
                {...classes('collapseLines')}
                moreText={i18n('showMore')}
                lessText={i18n('hide')}
                linesConfig={{
                  desktop: 21.5,
                  tablet: 17,
                  phone: 17
                }}
              >
                <span
                  {...classes('text')}
                  dangerouslySetInnerHTML={{ __html: member.text_1 }}
                />
              </CollapseLines>
            </Col>
          ))}
        </Row>
      </div>
    );
  }
}
